import { useState } from 'react';

import { CustomAlert, Text } from '../../../../../shared/uiComponents';
import { BadgeCheckIcon } from '../../../../../shared/Assets/svgIcons';
import ActivateAuthorizationContent from './activateAuthorizationContent';

import { ActiveAuthorizationProperties } from '../../../../../redux/API/ClientAPIHelpers/insuranceAuthorizationProperties';

const ActivateAuthorization = ({ authorizationData }: { authorizationData: ActiveAuthorizationProperties }) => {
	const [activateOpen, setActivateOpen] = useState<boolean>(false);

	const activateHandler = () => {
		setActivateOpen(true);
	};

	return (
		<>
			<div className="actionIcon" onClick={activateHandler}>
				<BadgeCheckIcon />
			</div>
			<div className="actionContent" onClick={activateHandler}>
				<Text title="Activate" type="psm" fontWeight="medium" />
			</div>
			<CustomAlert
				open={activateOpen}
				onClose={() => setActivateOpen(false)}
				title="Activate Insurance Authorization"
				Content={({ onClose }) => (
					<ActivateAuthorizationContent authorizationData={authorizationData} onClose={onClose} />
				)}
			/>
		</>
	);
};

export default ActivateAuthorization;
